module.exports = __webpack_public_path__ + "img/logo-light.bd1e537b.png";